
import { Component, OnInit } from "@angular/core";
import { CatGrupoConceptosService } from "../../servicios/cat-grupo-conceptos.service";
import { CatEstatusService } from "../../servicios/cat-estatus.service";
import { CatDireccionesService } from "../../servicios/cat-direcciones.service";
import { CatDepartamentosService } from "../../servicios/cat-departamentos.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatGrupoConceptos, Privilegios } from "../../entidades/entidades";
import { CatEstatus } from "../../entidades/entidades";
import { CatDirecciones } from "../../entidades/entidades";
import { CatDepartamentos } from "../../entidades/entidades";
import { Router } from "@angular/router";
import { PrivilegiosService } from "app/servicios/privilegios.service";
@Component({
  selector: "app-cat-grupo-conceptos-grid",
  templateUrl: "./cat-grupo-conceptos-grid.component.html",
  styleUrls: ["./cat-grupo-conceptos-grid.component.css"],
})
export class CatGrupoConceptosGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  catEstatus: SelectItem[];
  catEstatusFiltro: SelectItem[];
  catDirecciones: SelectItem[];
  catDireccionesFiltro: SelectItem[];
  catDepartamentos: SelectItem[];
  catDepartamentosFiltro: SelectItem[];
  catGrupoConceptos: CatGrupoConceptos[];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  privilegios: boolean = false;
  clonedCatGrupoConceptos: { [s: string]: CatGrupoConceptos } = {};

  constructor(
   private catGrupoConceptosService: CatGrupoConceptosService,
    private catEstatusService: CatEstatusService,
    private catDireccionesService: CatDireccionesService,
    private router: Router,
    private privilegiosService: PrivilegiosService,
    private catDepartamentosService: CatDepartamentosService,
  ) {}

  async ngOnInit() {
    await this.getAllCatEstatus();
    await this.getAllCatDirecciones();
    await this.getAllCatDepartamentos();
    await this.getAllCatGrupoConceptos();
    await this.getPrivilegios();

    // ===============================================================
    //Opciones del menu
    // ===============================================================
    this.itemsMenu = [
      {
        label: "Guardar",
        icon: "pi pi-save",
        command: (event) => {
          this.guardarGridCatGrupoConceptos();
        },
      },
      {
        label: "Refrescar",
        icon: "pi pi-refresh",
        command: (event) => {
          this.getAllCatGrupoConceptos();
        },
      },
    ];

    
    if(this.privilegios)
      this.itemsMenu.unshift({label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), });

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    this.columnasTabla = [
      {
        field: "operacion",
        header: "Editar",
        ordenar: false,
        styleHeader: "width: 40px;",
      },
      {
        field: "descripcion",
        header: "Descripcion",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
      {
        field: "idEstatus",
        header: "Estatus",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
      {
        field: "idDireccion",
        header: "Direccion",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
      {
        field: "idDepartamento",
        header: "Departamento",
        ordenar: true,
        styleHeader: "width: 150px;",
      },
     /* {
        field: "acciones",
        header: "Eliminar",
        ordenar: false,
        styleHeader: "width: 50px;",
      },*/
    
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  add() {
    let catGrupoConceptosNew = new CatGrupoConceptos();
    catGrupoConceptosNew.cambio = true;
    catGrupoConceptosNew.id = 0;
    catGrupoConceptosNew.numRow = this.catGrupoConceptos.length + 1;
    this.catGrupoConceptos.unshift(catGrupoConceptosNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  onEditInit(event) {
    let catGrupoConceptosEdit = event.data;
    this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow] = { ...catGrupoConceptosEdit };

    catGrupoConceptosEdit.cambio = true;
    catGrupoConceptosEdit.baja = false;
  }

  onEditCancel(event) {
    let catGrupoConceptosEdit = event.data;
    let index = this.catGrupoConceptos.findIndex(
      (obj) => obj.id === catGrupoConceptosEdit.numRow
    );
    this.catGrupoConceptos[index] = this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow];
    delete this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow];
  }

  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  async onEditComplete(event) {
    try {
      let catGrupoConceptosEdit = event.data;

      //Valida si hay cambios
      if (
        catGrupoConceptosEdit.id === this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow].id &&
        catGrupoConceptosEdit.descripcion === this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow].descripcion &&
        catGrupoConceptosEdit.idEstatus === this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow].idEstatus &&
        catGrupoConceptosEdit.idDireccion === this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow].idDireccion &&
        catGrupoConceptosEdit.idDepartamento === this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow].idDepartamento 
      ) {
        let index = this.catGrupoConceptos.findIndex((obj) => obj.numRow === catGrupoConceptosEdit.numRow);
        this.catGrupoConceptos[index] = {...this.clonedCatGrupoConceptos[catGrupoConceptosEdit.numRow]};
        return;
      }

      //Validaciones
      //throw new Error("No paso las validaciones.");

      catGrupoConceptosEdit.cambio = true;
      catGrupoConceptosEdit.baja = false;
      delete this.clonedCatGrupoConceptos[catGrupoConceptosEdit.id];
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por onEditComplete");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  async guardarGridCatGrupoConceptos() {
    try {
      for (let catGrupoConceptosFor of this.catGrupoConceptos) {
        if (catGrupoConceptosFor.baja) {
          await this.deleteCatGrupoConceptos(catGrupoConceptosFor);
        } else if (catGrupoConceptosFor.cambio) {
          if (catGrupoConceptosFor.id === 0) {
            const datoRetorno = await this.addCatGrupoConceptos(catGrupoConceptosFor);
            catGrupoConceptosFor.id = datoRetorno.id;
          } else {
            await this.updateCatGrupoConceptos(catGrupoConceptosFor);
          }
          catGrupoConceptosFor.cambio = false;
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por guardarCatGrupoConceptos");
    }
  }

  async addCatGrupoConceptos(catGrupoConceptos) {
    try {
      const datoretorno = await this.catGrupoConceptosService
        .add(catGrupoConceptos)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por addCatGrupoConceptos");
    }
  }

  async getAllCatGrupoConceptos() {
    try {
      const datoRetorno = await this.catGrupoConceptosService.getAll().toPromise();
      this.catGrupoConceptos = datoRetorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatGrupoConceptos");
    }
  }

  async updateCatGrupoConceptos(catGrupoConceptos: CatGrupoConceptos) {
    try {
      const datoRetorno = await this.catGrupoConceptosService
        .update(catGrupoConceptos)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por updateCatGrupoConceptos");
    }
  }

  async deleteCatGrupoConceptos(catGrupoConceptos: CatGrupoConceptos) {
    try {
      const datoRetorno = await this.catGrupoConceptosService
        .delete(catGrupoConceptos.id)
        .toPromise();
      this.getAllCatGrupoConceptos();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por deleteCatGrupoConceptos");
    }
  }

async getAllCatEstatus() {
    try {
      const datoRetorno = await this.catEstatusService.getAll().toPromise();
      this.catEstatus = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstatusFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catEstatusFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatEstatus");
    }
  }

async getAllCatDirecciones() {
    try {
      const datoRetorno = await this.catDireccionesService.getAll().toPromise();
      this.catDirecciones = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDireccionesFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDireccionesFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatDirecciones");
    }
  }

async getAllCatDepartamentos() {
    try {
      const datoRetorno = await this.catDepartamentosService.getAll().toPromise();
      this.catDepartamentos = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDepartamentosFiltro = datoRetorno.map((datos) => {
        return { label: datos.descripcion, value: datos.id };
      });
      this.catDepartamentosFiltro.unshift({ label: "Todos", value: null });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCatDepartamentos");
    }
  }

          async getPrivilegios() {
                try {
            
                  let objUrl = new Privilegios();
                  objUrl.descripcion = this.router.url + '/consulta_edicion';
                  let consultaRemesa = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
                  this.privilegios = consultaRemesa ? true : false; 
                } catch (e) {
                  if (e.response) throw { message: e.response.data };
                  else throw e;
                } finally {
                  console.log("Paso por getPrivilegios");
                }
          }
}